import { Link } from 'react-router';

export function Introuvable() {
  return (
    <section className="bg-white rounded-lg shadow-sm border border-slate-100 p-8 max-w-2xl">
      <h2 className="text-lg font-semibold text-slate-800 mb-2">Page introuvable</h2>
      <p className="text-sm text-slate-600 mb-4">L’adresse demandée ne correspond à aucun écran.</p>
      <Link to="/" className="text-sm font-medium text-red-700 underline">
        Revenir au tableau de bord
      </Link>
    </section>
  );
}
